module.exports = __webpack_public_path__ + "static/media/align-v-top.1b34e030.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/align-v-top.svg
// module id = 1182
// module chunks = 3